import ApplicationsServiceClass from "../../RainbowSdk/ApplicationsService";
import LogService from "../../CommonSdk/LogService";

import * as SandBoxApplicationsActionTypes from "./SandBoxApplicationsActionTypes";
import * as ErrorUtils from "../../Utils/ErrorUtils";
import * as Constants from "../../Constants/SdkConstant";
import * as SandBoxContactsActions from "./SandBoxContactsActions";
import * as ApplicationsConstant from "../../Constants/ApplicationTypes";
import * as PaymentsService from "../../RainbowSdk/PaymentsService";

import SandBoxServerFetch from "../../Request/SandBoxServerFetch";

const LOG_TAG = "ACTIONS:SANDBOX_APPLICATIONS";
export const MAX_OWNERLIST_LENGTH = 100; //to limit url line length
const ApplicationsService = new ApplicationsServiceClass(SandBoxServerFetch);

const getMissingContactIdList = (applicationList) => dispatch => {
    let contactIdList = [];
    if (applicationList) {
        applicationList.forEach(app => {
            contactIdList = [...contactIdList.filter(id => id !== app.ownerId), app.ownerId];
        });
    }

    const missingContactIdList = dispatch(SandBoxContactsActions.getMissingContactIdList(contactIdList));
    dispatch(SandBoxContactsActions.getContacts(missingContactIdList));
}

export const getAllApplications = (criteria) => (dispatch) => {
    LogService.trace(LOG_TAG, "getAllApplications");
    const promiseArray = [];

    dispatch({
        type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_PROGRESS
    });

    let ownerIdList = criteria ? criteria["ownerId"] : null;
    if (ownerIdList && ownerIdList.length > MAX_OWNERLIST_LENGTH) {
        LogService.debug(LOG_TAG, "split ownerId list");
        let baseCriteria = {
            ...criteria,
            ownerId: ""
        };
        for (let i = 0; i < ownerIdList.length; i += MAX_OWNERLIST_LENGTH) {
            const ownerIdListPerPage = ownerIdList.slice(i, i + MAX_OWNERLIST_LENGTH);
            promiseArray.push(getAllApplicationsPerPage({ ...baseCriteria, ownerId: ownerIdListPerPage }));
        }
    } else {
        promiseArray.push(getAllApplicationsPerPage(criteria));
    }

    return Promise.allSettled(promiseArray)
        .then(results => {
            const applicationList = [];
            const errorReasonList = [];
            results.forEach((result, i) => {
                if (result.status === "fulfilled") {
                    applicationList.push(...result.value);
                } else {
                    errorReasonList.push({ i: result.reason });
                }
            });
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: applicationList,
                }
            });
            dispatch(getMissingContactIdList(applicationList));

            if (errorReasonList.length > 0) {
                return Promise.reject();
            } else {
                return Promise.resolve();
            }
        });
};

export const getAllApplicationsPerPage = (criteria) => {
    return ApplicationsService.getApplicationsPerPage(0, Constants.MAX_PAGE_SIZE, criteria)
        .then(response => {
            let applicationList = response.data ? response.data : [];

            const promiseArray = [];
            for (let i = 1; i < response.total / Constants.MAX_PAGE_SIZE; i++) { //fetch all other applications
                promiseArray.push(ApplicationsService.getApplicationsPerPage(i, Constants.MAX_PAGE_SIZE, criteria));
            }
            return Promise.allSettled(promiseArray)
                .then(results => {
                    results.forEach((result, i) => {
                        if (result.status === "fulfilled") {
                            applicationList.push(...result.value.data);
                        }
                    });
                    return Promise.resolve(applicationList);
                });
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
};

export const clearApplications = () => (dispatch) => {
    LogService.trace(LOG_TAG, "clearApplications");
    dispatch({
        type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_CLEAR
    });
};

export const updateApplication = (applicationId, criteria) => dispatch => {
    LogService.trace(LOG_TAG, "updateApplication");

    return ApplicationsService.updateApplication(applicationId, criteria)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const createApplication = (name, activity = ApplicationsConstant.Activity.J, type = ApplicationsConstant.Type.Web) => dispatch => {
    LogService.trace(LOG_TAG, "createApplication");

    const criteria = {
        name: name,
        activity: activity,
        type: type
    }

    return ApplicationsService.createApplication(criteria)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve(application);
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const deleteApplications = (appIdList) => dispatch => {
    LogService.trace(LOG_TAG, "deleteApplications");

    const promiseArray = [];
    if (appIdList) {
        appIdList.map((appId) => promiseArray.push(ApplicationsService.deleteApplication(appId)));
    }

    return Promise.allSettled(promiseArray)
        .then(() => {
            return dispatch(getAllApplications())
                .then(() => {
                    return Promise.resolve();
                })
                .catch(() => {
                    return Promise.reject();
                });
        });
};

export const changeOwnerApplications = (appIdList, ownerId) => dispatch => {
    LogService.trace(LOG_TAG, "changeOwnerApplications");
    const criteria = {
        ownerId: ownerId
    };

    const promiseArray = [];
    if (appIdList) {
        appIdList.map((appId) => promiseArray.push(ApplicationsService.updateApplication(appId, criteria)));
    }

    return Promise.allSettled(promiseArray)
        .then((results) => {
            const updatedApplications = [];
            const errorApplications = [];
            results.forEach((result, i) => {
                if (result.status === "fulfilled") {
                    updatedApplications.push(result.value);
                } else {
                    errorApplications.push({ [appIdList[i]]: result.reason });
                }

            });
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: updatedApplications,
                }
            });
            if (errorApplications.length > 0) {
                return Promise.reject(errorApplications);
            } else {
                return Promise.resolve(updatedApplications);
            }
        });
};

export const deployApplicationRequest = (app) => dispatch => {
    LogService.trace(LOG_TAG, "deployApplicationRequest");

    let SubscribeOrDeployApplication = null;
    if (app?.kpi === ApplicationsConstant.ModelType.PayAsYouGo) {//payAsYouGo
        SubscribeOrDeployApplication =
            PaymentsService.subscribeAnApplication(app)
                .then(() => new Promise(resolve => setTimeout(() => resolve(), 5000))) //wait 5s
                .then(() => {
                    LogService.debug(LOG_TAG, "deployApplicationRequest get app");
                    return ApplicationsService.getApplication(app.id)
                });
    } else {
        SubscribeOrDeployApplication = ApplicationsService.deployApplicationRequest(app.id);
    }

    return SubscribeOrDeployApplication
        .then(application => {
            LogService.debug(LOG_TAG, "deployApplicationRequest dispatch");
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application]
                }
            });
            return Promise.resolve();
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
};

export const deployApplication = (applicationId, reason) => dispatch => {
    LogService.trace(LOG_TAG, "deployApplication");

    return ApplicationsService.deployApplication(applicationId, reason)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const declineApplication = (applicationId) => dispatch => {
    LogService.trace(LOG_TAG, "declineApplication");

    return ApplicationsService.declineApplication(applicationId)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const stopApplication = (applicationId) => dispatch => {
    LogService.trace(LOG_TAG, "stopApplication");

    return ApplicationsService.stopApplication(applicationId)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const restartApplication = (applicationId) => dispatch => {
    LogService.trace(LOG_TAG, "restartApplication");

    return ApplicationsService.restartApplication(applicationId)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const blockApplication = (applicationId) => dispatch => {
    LogService.trace(LOG_TAG, "blockApplication");

    return ApplicationsService.blockApplication(applicationId)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const unblockApplication = (applicationId) => dispatch => {
    LogService.trace(LOG_TAG, "unblockApplication");

    return ApplicationsService.unblockApplication(applicationId)
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const deletePushNotification = (applicationId, pnId) => dispatch => {
    LogService.trace(LOG_TAG, "deletePushNotification");

    return ApplicationsService.deletePushNotification(applicationId, pnId)
        .then(() => ApplicationsService.getApplication(applicationId))
        .then((application) => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const addOrUpdatePushNotificationAndroid = (applicationId, pnId, isEnabled, key, senderId) => dispatch => {
    LogService.trace(LOG_TAG, "addOrUpdatePushNotificationAndroid");

    let addOrUpdatePromise = null;
    if (pnId) { //update
        addOrUpdatePromise = ApplicationsService.updatePushNotification(applicationId, pnId, isEnabled, key, senderId);
    } else { //create
        addOrUpdatePromise = ApplicationsService.addPushNotification(applicationId, ApplicationsConstant.PushNotificationType.FcmXmpp, isEnabled, key, senderId);
    }

    return addOrUpdatePromise
        .then(results => ApplicationsService.getApplication(applicationId))
        .then(application => {
            LogService.debug(LOG_TAG, "addOrUpdatePushNotificationAndroid", "success", application);
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch(error => {
            LogService.error(LOG_TAG, "addOrUpdatePushNotificationAndroid", error);
            let errorPayload = {
                ...ErrorUtils.parseErrorAndReturnPayload(error),
            }
            return Promise.reject(errorPayload);
        });
};

export const addOrUpdatePushNotificationIos = (applicationId, pnId, isEnabled, certificateType, certificateFile, appBundleId) => dispatch => {
    LogService.trace(LOG_TAG, "addOrUpdatePushNotificationIos");

    let addOrUpdatePromise = null;
    if (pnId) { //update
        addOrUpdatePromise = ApplicationsService.updatePushNotification(applicationId, pnId, isEnabled, null, null, certificateType, certificateFile, appBundleId);
    } else { //create
        const apnsType = certificateType ? ApplicationsConstant.PushNotificationType.Apns : ApplicationsConstant.PushNotificationType.ApnsV2;
        addOrUpdatePromise = ApplicationsService.addPushNotification(applicationId, apnsType, isEnabled, null, null, certificateType, certificateFile, appBundleId);
    }

    return addOrUpdatePromise
        .then(results => ApplicationsService.getApplication(applicationId))
        .then(application => {
            dispatch({
                type: SandBoxApplicationsActionTypes.SANDBOX_APPLICATIONS_UPDATE,
                payload: {
                    applications: [application],
                }
            });
            return Promise.resolve();
        })
        .catch(error => {
            LogService.error(LOG_TAG, "addOrUpdatePushNotificationIos", error);
            let errorPayload = {
                ...ErrorUtils.parseErrorAndReturnPayload(error),
            }
            return Promise.reject(errorPayload);
        });
};

export const registerDeveloper = () => dispatch => {
    LogService.trace(LOG_TAG, "registerDeveloper");

    return ApplicationsService.registerDeveloper()
        .then((user) => {
            dispatch(SandBoxContactsActions.setUserContact(user));
            return Promise.resolve();
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const unregisterDeveloper = (loginEmail) => dispatch => {
    LogService.trace(LOG_TAG, "unregisterDeveloper");

    return ApplicationsService.unregisterDeveloper(loginEmail)
        .then((response) => {
            return dispatch(SandBoxContactsActions.getUserContact());
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};